import { useTheme } from "arkh";
import { UserLoggedInNavigatorScreenProps } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { WorkspaceSignalEditMain } from "./WorkspaceSignalEditMain/WorkspaceSignalEditMain";

import { WorkspaceSignalStack } from "./WorkspaceSignalEditStack";

function WorkspaceSignalEditNavigatorC(
  props: UserLoggedInNavigatorScreenProps<"WorkspaceSignalEdit">
) {
  const theme = useTheme();
  return (
    <WorkspaceSignalStack.Navigator
      screenOptions={{
        headerShown: true,
        headerStyle: {
          backgroundColor: theme["surface-background-light"],
        },
        cardStyle: {
          backgroundColor: theme["surface-background-light"],
        },
        headerShadowVisible: false,
        headerTitle: "",
        headerLeft: () => null,
      }}
    >
      <WorkspaceSignalStack.Screen
        name="WorkspaceSignalEditMain"
        component={WorkspaceSignalEditMain}
        initialParams={props.route.params}
      />
    </WorkspaceSignalStack.Navigator>
  );
}

export const WorkspaceSignalEditNavigator = withWebModal(
  WorkspaceSignalEditNavigatorC,
  true,
  {
    width: 1040,
    height: 740,
  }
);
